/* eslint-disable no-console */

export default function (to, from, next) {
    console.groupCollapsed('navigation', 'from ' + from.path + ' to ' + to.path)
    console.log('from:', from)
    console.log('to:', to)
    console.groupEnd('navigation')
    next()
}